module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KzUfPn/tc-custom/9781646567577.jpg?1723406375055",
      "alt": "This image is the cover for the book #IceCreamSundae"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("#IceCreamSundae\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Tourist season at Lake Wallenpaupack means a break in the monotony of Alexi’s life. They’ve been secretly advertising the ice cream parlor they work at through the Foodspotting app, hoping that will bring even more customers. One such customer is Eli, a recent addition to the area with a bright and open disposition that Alexi is drawn to immediately. And since Eli is demisexual, Alexi welcomes him into their friend group of other queer twenty-somethings."), _c('br'), _c('br'), _vm._v("The more Alexi gets to know Eli, the more smitten they are. If only they didn’t have crippling self-esteem issues, problems at home with their dad, and enough emotional baggage to fill a freight train. They’re desperate to get out of that rut so they can have space in their heart for someone like Eli. After years of playing a passive role, making the first steps towards change might prove too much for them.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Feral Sephrian\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0